export default __webpack_public_path__ + "static/media/NA.dd25f8f7.svg";